import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import ClientProfileTab from "./tabs/ClientProfileTab";
import ParticipantStatusTab from "./tabs/ParticipantStatusTab";
import EnrollmentTab from "./tabs/EnrollmentTab";
import IliaEnrollmentTab from "./tabs/iliaApp/IliaEnrollmentTab";
import ActionItemsTab from "./tabs/ActionItemsTab";
import DocumentsTab from "./tabs/DocumentsTab";
import NotesTab from "./tabs/NotesTab";
import CaseDetailTab from "./tabs/CaseDetailTab";
import ClientSnapshot from "./ClientSnapshot";
import { Grid, Tab } from "@material-ui/core";
import {useActions} from "../../../../actions";
import * as ClientActions from "../../../../actions/client";
import * as NotificationActions from "../../../../actions/notification";
import {useSelector} from "react-redux";
import {RootState} from "../../../../reducers";
import BadgeOverlap from "../../../../components/BadgeOverlap";
import AdminActions from "./AdminActions";
import {history} from "../../../../configureStore";
import {AccountType, GWT_GEN2_STRATEGY, PermissionTypes} from "../../../../constants";
import {can} from "../../../../components/navigation/AdminNavigation";
import {TicketsPanels} from "../../../ticket/TicketPage";
import { isAllianzApp, isIliaApp } from "../../Enrollment/EnrollmentHome/EnrollmentApplication/Utilities";
import { useTabWithLocation } from "../../../imo/ImoProfile/ImoProfile";
import CaseDetailAgentTab from "./tabs/CaseDetailAgentTab";
import { useOfferType } from "../../../../hooks/useOfferType";
import TotalRemainingPayments from "../../Enrollment/EnrollmentHome/payment/TotalRemainingPayments";
import { usePolicyContext } from "../../../../components/clientServicing/Payments/PolicyContext";
import AllianzAppEnrollmentTab from "./tabs/AllianzAppEnrollmentTab";
import {Link, useParams, useRouteMatch} from "react-router-dom";
import * as AccountActions from "../../../../actions/account";
import GiftorDetailsTab from "./tabs/GiftorDetailsTab";
import { checkRole } from "../../../../utils/commonUtils";
import Illustrations from "./tabs/Illustrations";
import ProposalSummary from "./ProposalSummary";
import {isDebug} from "../../../../utils/commonUtils";


interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
}

export function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
            <div
                    role="tabpanel"
                    hidden={value !== index}
                    id={`scrollable-force-tabpanel-${index}`}
                    aria-labelledby={`scrollable-force-tab-${index}`}
                    {...other}
                    className="divAnimation"
            >
                {value === index && (
                        <Box>
                            {children}
                        </Box>
                )}
            </div>
    );
}

type PropsType = {
    label: any,
    value: any
}

const TabLink = (props: PropsType) => {
    const params: any = useParams();
    const { value } = props;
    const path = `/new-client/detail/${params.id}/${params.clientPolicyId}`;
    return (
            <React.Fragment>
                <Tab
                        component={Link}
                        to={`${path}/${value}`}
                        {...props}
                        {...a11yProps(value)}
                />
            </React.Fragment>
    );
};

export function a11yProps(index: any) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}

export const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
        width: "100%",
    },
}));
type TabMenuProps = {
    urlClientId: number,
    clientDetail: any,
    role: number | undefined,
    updateActionItem: Function,


    currentTickets: any[],
    currentTicketsPagination?: any,
    setCurrentTicketsPagination?: Function,

    completedTickets: any[],
    completedTicketsPagination: any,
    setCompletedTicketsPagination: Function,
    onResolveTicket: Function
    onTicketCreated: Function,

    // real active tab
    value: number,
    setValue: Function
    clientPolicyId: string
}

let apiCount: number = 0;

enum TabsEnum {
    Profile,
    Status,
    EnrollmentDetails,
    ActionItems,
    Illustrations,
    Documents,
    Notes,
    GiftorDetails,
    CaseDetails,
    Tickets
}

export default function TabsMenu(props: TabMenuProps) {
    const {
        urlClientId, role,
        currentTickets, completedTickets, completedTicketsPagination, setCompletedTicketsPagination, onResolveTicket,
        onTicketCreated, currentTicketsPagination, setCurrentTicketsPagination, clientPolicyId
    } = props;
    const params: any = useParams();
    const classes = useStyles();
    const saveCaseDetailButtonRef = React.useRef(null);
    const profileTabs = ["profile", "status", "details", "action-items", "illustrations", "documents", "notes", "giftor-details", "case-details", "tickets"];
    const { value, setValue } = useTabWithLocation(profileTabs)
    const [actionItem, setActionItem] = React.useState(0);
    const [forceRefreshSummary, setForceRefreshSummary] = React.useState(0);
    const {getClient} = useActions(ClientActions);
    const accountActions = useActions(AccountActions);
    const {getPendingCounts, updatePendingCounts} = useActions(NotificationActions);
    const clientDetail: any = useSelector((state: RootState) => state.clientAccount);
    const user: any = useSelector((state: RootState) => state.auth.user);
    const clientPolicy = clientDetail && clientDetail.client && clientDetail.client.clientPolicies.length > 0 && clientDetail.client.clientPolicies[0];
    const paymentFrequency: string = clientPolicy && clientPolicy.paymentFrequency || "annual";
    let offerType = useOfferType();
    const adminPermission: boolean = can(user, PermissionTypes.ACCOUNT_MANAGEMENT) && clientDetail.inviteStatus > 2;
    const [ssnFlag, setSsnFlag] = React.useState((
            role === 1 || role === 2 || role === 4) ? true
            :
            (!!(clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.clientSigned && clientPolicy && clientPolicy.usCitizen))
    );
    const [notificationAlert, setNotificationAlert] = React.useState({
        actionItemsCount: 0,
        participantStatusCount: 0,
        notesCount: 0,
        leadsCount: 0
    });
    const [refreshPage, setRefreshPage] = React.useState<number>(0);
    const isGWTGen2 = clientPolicy &&
            !!(
                    clientPolicy.strategyId === GWT_GEN2_STRATEGY &&
                    clientPolicy.coverLetterReq &&
                    clientPolicy.currentlyEmployed === "Other" &&
                    clientPolicy.parentsAreIncomeEarner &&
                    clientPolicy.wealthGiftTransfer
            );

    const getActiveTab = (value) => {
        let index = value;
        if (role === 3 || role === 8 || role === 15 || role === 16) {
            if (index === 2) {
                index = 4;
            } else if (index === 3) {
                index = 5;
            } else if (index === 4) {
                index = 3;
            }
        }
        if (role === 12) {
            if (index === 2) {
                index = 3;
            } else if (index === 3) {
                index = 4;
            } else if (index === 4) {
                index = 5;
            } else if (index === 5) {
                index = 3;
            }
        }

        return index;
    }

    const getClientDetail = React.useCallback((clientId, clientPolicyId, ssnFlagValue) => {
        const getClientData = async () => {
            const result = await getClient(clientId, clientPolicyId, ssnFlagValue);
            const clientPolicyData = result && result.payload && result.payload.client && result.payload.client.clientPolicies && result.payload.client.clientPolicies.length > 0 && result.payload.client.clientPolicies[0];
            if (result && result.statusCode && result.statusCode === 400) {
                apiCount = 0;
                if (role === 3 || role === 15) { //client not found when imo logged in
                    history.replace('/imo/individual');
                } else {
                    history.replace('/client');
                }
            } else {
                if (role === 8 && clientPolicyData.companyId != user.company.id) {
                    history.replace('/group-participants');
                }
                if (role === 16 &&
                    clientPolicyData.companyId != user.groupSigners.companyId) {
                    history.replace('/group-participants');
                }
            }
        }
        getClientData().then(() => {
        });
    }, [])

    React.useEffect(() => {
        let index = getActiveTab(value);
        //We will not call client detail api IN case of : Case Detail Tab/Notes Tab/Documents Tab

        if (value != "status" && value != "documents" && value != "notes" && value != "tickets" && apiCount < 1) {
            ++apiCount;
            getClientDetail(urlClientId || 0, clientPolicyId, ssnFlag);
        }
    }, []);

    React.useEffect(() => {
        const getClientData = async () => {
            const result = await getClient(urlClientId || 0, clientPolicyId, ssnFlag);
            if (result && result.statusCode && result.statusCode === 400) {
                apiCount = 0;
                if (role === 3 || role === 15) { //client not found when imo logged in
                    history.replace('/imo/individual');
                } else {
                    history.replace('/client');
                }
            }
        }
        let index = getActiveTab(value);
        //We will not call client detail api IN case of : Case Detail Tab/Notes Tab/Documents Tab
        if (value != "status" && value != "documents" && value != "notes" && value != "tickets") {
            getClientData().then(() => {
            });
        }
        if (role === AccountType.Carrier) { // for role 7 i.e carrier we do not need to get notifications

            return;
        }
        getNotificationAlerts().then(() => {
            let index = getActiveTab(value);
            if (index === 3 && notificationAlert.actionItemsCount > 0) {
                updateNotificationAlerts({actionItemsCount: 0});
            }
            if (index === 5 && notificationAlert.notesCount > 0) {
                updateNotificationAlerts({notesCount: 0});
            }
        });
    }, [value, actionItem]);

    const getNotificationAlerts = async () => {
        let pendingCounts = await getPendingCounts(urlClientId);
        if (pendingCounts) {
            setNotificationAlert(pendingCounts);
        }
    }

    const updateNotificationAlerts = async (payload: any) => {
        let pendingCounts = await updatePendingCounts(urlClientId, payload);
        if (pendingCounts) {
            setNotificationAlert({...notificationAlert, ...pendingCounts});
        }
    }

    React.useEffect(() => {
        if (clientDetail.client) {
            setTimeout(() => {
                apiCount = 0
            }, 1000);
            setSsnFlag(
                    (role === 1 || role === 2 || role === 4) ? true
                            :
                            (!!(clientPolicy && clientPolicy.enrollment && clientPolicy.enrollment.clientSigned && clientPolicy && clientPolicy.usCitizen))
            );
            let index = getActiveTab(value);
            setTimeout(() => {
                if (index === 3 && notificationAlert.actionItemsCount > 0) {
                    updateNotificationAlerts({actionItemsCount: 0});
                }
            }, 500);
        }
    }, [clientDetail.client]);

    React.useEffect(() => {
        isDebug() && console.info('start loading proposal summary');
        setForceRefreshSummary(Math.random());
    }, []);

    const handleChange = async (event: React.ChangeEvent<{}>, newValue: any) => {
        //props.updateActionItem(newValue);
        setValue(newValue)
        if (newValue === 1) {
            getClientDetail(urlClientId || 0, clientPolicyId, ssnFlag)
        }
    };

    const tabText = (tabIndex) => {
        let index = tabIndex;
        switch (index) {
            case 0:
                return "Below is the client basic profile information used for their invite and enrollment. Additional enrollment specific details can be filled in through the enrollment tab above.";
            case 1:
                return "Below is the list of steps we recorded throughout the invitation and enrollment process. Your clients current status is visible by the blue marker.";
            case 2:
                return "In addition to basic client details, you can optionally pre-fill specific questions for the client to streamline their enrollment process. They will verify and make any necessary changes when they enroll.";
            case 3:
                return "";
            case 4:
                return "All documents relevant for this client including images, applications, and proposals are available to view and download. Documents can be deleted if you added them to the list or by an NIW administrator.";
            case 5:
                return "Below are message logs of client, agent, trustee and NIW admin correspondence during enrollment.";
            case 6:
                return "Below are the client policy details and are what is used when the client view their policy serving page in myilia. You can make changes to the fields below or upload a CSV to overwrite existing content. Don't forget to save your changes";
            case 7:
                return "Below are the current and completed tickets of the client";
        }
    };

    const refreshDetails = () => {
        getClientDetail(urlClientId || 0, clientPolicyId, ssnFlag);
    }

    const { policy } = usePolicyContext();
    const policyAtListOne = policy && policy.paymentTimetableAnnual && policy.paymentTimetableAnnual.recurringPayments && policy.paymentTimetableAnnual.recurringPayments.length > 0;
    return (
                <div className={classes.root}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <AppBar position="static" color="default">
                                <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        variant="scrollable"
                                        scrollButtons="on"
                                        indicatorColor="primary"
                                        textColor="primary"
                                        aria-label="scrollable force tabs example"
                                >
                                    <TabLink label="CLIENT PROFILE" value={profileTabs[TabsEnum.Profile]} />
                                    <TabLink label="PARTICIPANT STATUS" value={profileTabs[TabsEnum.Status]} />
                                    {(role === 1 || role === 2 || role === 4) &&
                                            <TabLink label="ENROLLMENT DETAILS" value={profileTabs[TabsEnum.EnrollmentDetails]} />
                                    }
                                    {(role === 4 || role === 12 || (can(user, PermissionTypes.NIW_ACTION_ITEMS) && role !== AccountType.Carrier)) &&
                                            <TabLink label={<>MY ACTION ITEMS {notificationAlert.actionItemsCount > 0 &&
                                                    <BadgeOverlap />}</>} value={profileTabs[TabsEnum.ActionItems]} />
                                    }
                                    {
                                            (role === AccountType.Admin || role === AccountType.MasterAdmin || role === AccountType.Agent) &&
                                            <TabLink label="ILLUSTRATIONS" value={profileTabs[TabsEnum.Illustrations]} />
                                    }
                                    <TabLink label="DOCUMENTS" value={profileTabs[TabsEnum.Documents]} />

                                    {
                                            checkRole(role, [AccountType.IMO, AccountType.ImoMember]) &&
                                            <TabLink label={<>Giftor Details</>}
                                                     value={profileTabs[TabsEnum.GiftorDetails]} />
                                    }

                                    <TabLink label={<>NOTES {notificationAlert.notesCount > 0 &&
                                            <BadgeOverlap />}</>} value={profileTabs[TabsEnum.Notes]} />

                                    {
                                            checkRole(role, [AccountType.MasterAdmin, AccountType.Admin, AccountType.Agent, AccountType.Individual, AccountType.Multilife]) &&
                                            <TabLink label={<>Giftor Details</>}
                                                     value={profileTabs[TabsEnum.GiftorDetails]} />
                                    }

                                    {(role === 1 || role === 2 || role === 4) &&
                                            <TabLink label={<>Case Details {isGWTGen2 &&
                                                    <BadgeOverlap />}</>} value={profileTabs[TabsEnum.CaseDetails]} />
                                    }

                                    {(role == 1 || role == 2) && can(user, PermissionTypes.TICKETS) &&
                                            <TabLink label="TICKETS" value={profileTabs[TabsEnum.Tickets]} />
                                    }
                                </Tabs>
                            </AppBar>
                        </Grid>
                        <Grid item xs={12} md={12} lg={8}>
                            <Typography variant="body1" className="mt20 mb20">
                                {tabText(value)}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={12}
                              lg={params.tab === profileTabs[TabsEnum.GiftorDetails] ? 12 : 8}>
                        <TabPanel value={value} index={profileTabs[TabsEnum.Profile]}>
                                <ClientProfileTab urlClientId={urlClientId} clientDetail={clientDetail} role={role}
                                                  ssnFlag={ssnFlag}
                                                  setActionItem={() => setActionItem(actionItem + 1)}
                                                  getClientDetail={getClientDetail}
                                                  clientPolicyId={clientPolicyId} />
                            </TabPanel>
                            <TabPanel value={value} index={profileTabs[TabsEnum.Status]}>
                                <ParticipantStatusTab
                                        setActionItem={() => {
                                            setValue(profileTabs[TabsEnum.Documents]);
                                        }}
                                        clientDetail={clientDetail}
                                        role={role}
                                        clientPolicyId={clientPolicyId}
                                />
                            </TabPanel>
                            {(role === 1 || role === 2 || role === 4) &&
                                    <TabPanel value={value}
                                          index={profileTabs[TabsEnum.EnrollmentDetails]}>
                                        {isIliaApp(offerType) ? <IliaEnrollmentTab clientDetail={clientDetail}
                                                                                   setActionItem={(ssnFlagValue: boolean) => {
                                                                                       setSsnFlag(ssnFlagValue);
                                                                                       setActionItem(actionItem + 1);
                                                                                   }} getClientDetail={getClientDetail}
                                                                                   urlClientId={urlClientId}
                                                                                   ssnFlag={ssnFlag}
                                                                                   clientPolicyId={clientPolicyId} /> :
                                                isAllianzApp(offerType) ? <AllianzAppEnrollmentTab
                                                                clientDetail={clientDetail}
                                                                setActionItem={(ssnFlagValue: boolean) => {
                                                                   setSsnFlag(ssnFlagValue);
                                                                   setActionItem(actionItem + 1);
                                                               }} /> :
                                                        <EnrollmentTab clientDetail={clientDetail}
                                                                setActionItem={(ssnFlagValue: boolean) => {
                                                                    setSsnFlag(ssnFlagValue);
                                                                    setActionItem(actionItem + 1);
                                                                }} getClientDetail={getClientDetail}
                                                                urlClientId={urlClientId} ssnFlag={ssnFlag}
                                                                       clientPolicyId={clientPolicyId} />
                                        }
                                    </TabPanel>
                            }
                            {(role === 4 || role === 12 || (can(user, PermissionTypes.NIW_ACTION_ITEMS))) &&
                                    <TabPanel value={value}
                                          index={profileTabs[TabsEnum.ActionItems]}>
                                        <ActionItemsTab role={role} clientDetail={clientDetail}
                                                        goToDocuments={() => {
                                                        setValue(profileTabs[TabsEnum.Documents]);
                                                            props.updateActionItem(4);
                                                        }}
                                                        setActionItem={() => setActionItem(actionItem + 1)}
                                                        clientPolicyId={clientPolicyId}
                                                        refreshPage={async (updateListOnly: boolean = false) => {
                                                            if(updateListOnly){
                                                                return getClientDetail(urlClientId || 0, clientPolicyId, ssnFlag);
                                                            }else {
                                                                setRefreshPage(refreshPage + 1);
                                                                await accountActions.getFreshDataToRefreshReduxState();
                                                            }
                                                        }}
                                        />
                                    </TabPanel>
                            }
                            {
                                    (role === AccountType.Admin || role === AccountType.MasterAdmin || role === AccountType.Agent) &&
                                    <TabPanel value={value} index={profileTabs[TabsEnum.Illustrations]}>
                                        <Illustrations setForceRefreshSummary={setForceRefreshSummary}/>
                                    </TabPanel>
                            }
                        <TabPanel value={value} index={profileTabs[TabsEnum.Documents]}>
                                <DocumentsTab role={role} clientDetail={clientDetail} getClientDetail={getClientDetail}
                                              ssnFlag={ssnFlag}
                                              clientPolicyId={clientPolicyId} />
                            </TabPanel>
                        <TabPanel value={value} index={profileTabs[TabsEnum.Notes]}>
                                <NotesTab role={role} clientDetail={clientDetail} />
                            </TabPanel>

                            {checkRole(role, [AccountType.MasterAdmin, AccountType.Admin, AccountType.IMO, AccountType.ImoMember, AccountType.Agent, AccountType.Individual, AccountType.Multilife]) &&
                                    <TabPanel value={value} index={profileTabs[TabsEnum.GiftorDetails]}>
                                        <GiftorDetailsTab clientDetail={clientDetail} />
                                    </TabPanel>
                            }

                        {(role == 1 || role == 2) &&
                                <TabPanel value={value} index={profileTabs[TabsEnum.CaseDetails]}>
                                    <CaseDetailTab clientDetail={clientDetail} ssnFlag={ssnFlag}
                                                   setActionItem={(ssnFlagValue: boolean) => {
                                                       setSsnFlag(ssnFlagValue);
                                                       setActionItem(actionItem + 1);
                                                   }}
                                                   caseDetailButtonRef={saveCaseDetailButtonRef}
                                                   clientPolicyId={clientPolicyId}
                                                   refreshDetails={refreshDetails}
                                    />
                                </TabPanel>
                        }
                            {
                                    (role === AccountType.Agent) &&
                                    <TabPanel value={value} index={profileTabs[TabsEnum.CaseDetails]}>
                                        <CaseDetailAgentTab setActionItem={() => setActionItem(actionItem + 1)} />
                                    </TabPanel>
                            }
                        {(role == 1 || role == 2) && can(user, PermissionTypes.TICKETS) &&
                                <TabPanel value={value} index={profileTabs[TabsEnum.Tickets]}>
                                        <TicketsPanels
                                                currentTickets={currentTickets}
                                                currentTicketsPagination={currentTicketsPagination}
                                                setCurrentTicketsPagination={setCurrentTicketsPagination}

                                                completedTickets={completedTickets}
                                                completedTicketsPagination={completedTicketsPagination}
                                                setCompletedTicketsPagination={setCompletedTicketsPagination}
                                                onResolveTicket={onResolveTicket}
                                                isGoToClientVisible={false}

                                        />
                                    </TabPanel>
                            }
                        </Grid>
                        <Grid item xs={12} md={12} lg={4}>
                            {((adminPermission && (user.role === AccountType.MasterAdmin || user.role === AccountType.Admin)) || role === AccountType.Company) && (params.tab !== profileTabs[TabsEnum.GiftorDetails]) &&
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} md={12}>
                                            <AdminActions role={role} clientDetail={clientDetail}
                                                          setActionItem={() => setActionItem(actionItem + 1)}
                                                          adminPermission={adminPermission}
                                                          onTicketCreated={onTicketCreated}
                                                          offerType={offerType} />
                                        </Grid>
                                    </Grid>
                            }
                            {
                                (user.role !== AccountType.Carrier) && (params.tab !== profileTabs[TabsEnum.GiftorDetails]) &&
                                <ClientSnapshot
                                        refreshDetails={refreshDetails}
                                        caseDetailButtonRef={saveCaseDetailButtonRef}
                                />
                        }

                            {
                                    (role === AccountType.Admin || role === AccountType.MasterAdmin || role === AccountType.Agent) &&
                                    <ProposalSummary forceRefreshSummary={forceRefreshSummary}/>
                            }
                        {
                                 [AccountType.Admin, AccountType.MasterAdmin].includes(user.role) && policyAtListOne &&
                                <TotalRemainingPayments paymentFrequency={paymentFrequency} />
                            }
                        </Grid>
                    </Grid>
                </div>

    );
}